/******************************************************************************************
 *	Get Product Name service
 *******************************************************************************************
 *
 * Maps products to product names, either returning a translation key or the actual product name,
 * if no translation is required.
 *
 */
(function() {
  

  angular.module('rcServices.productToProdName', []).service(
    'productToProdName',
    /* @ngInject */
    function(_) {
      this.get = function(product) {
        if (_.invoke(product, 'isConsolidated')) {
          return product.getConsolidatedName();
        }

        const binkyProduct = _.invoke(product, 'getBinkyProduct');
        if (binkyProduct) {
          return binkyProduct.longName;
        }

        const productCode = _.get(product, 'code');
        const shouldTranslateProductName = _.includes(
          ['CCLE', 'CTSK', 'STKS', 'STKM', 'STKL', 'SUPPORT'],
          productCode
        );

        var translationKey = 'global.products.' + productCode;

        // We call translate on the result; if it's just the product name, the translation call
        // won't find a matching key/value pair and will just use the provided value.
        // So for products that shouldn't be translated, we return the name; for ones that should, we return the key.
        return shouldTranslateProductName ? translationKey : _.get(product, 'name');
      };
    }
  );
})();
